import React from "react";
import { connect } from 'react-redux';
import { browserHistory, RouteComponentProps } from "react-router";
import { userLoginImpersonate, userLogout } from '../../actions/userActions';

interface Props extends React.Props<any> {
  userLoginImpersonate: typeof userLoginImpersonate,
  userLogout: typeof userLogout,
}

interface MatchParams {
  username: string;
  access_token: string;
}

class Impersonate extends React.Component<RouteComponentProps<MatchParams, any> & Props> {
  async componentDidMount() {
    this.props.userLogout();

    const result = await this.props.userLoginImpersonate(
      this.props.location.query.username as string,
      this.props.location.query.access_token as string
    );

    // @ts-ignore
    if (result === 'success') {
      browserHistory.push("/");
    }
  }

  render() {
    return null;
  }
}

export default connect(null, {
  userLogout,
  userLoginImpersonate,
})(Impersonate);
